module.exports = __webpack_public_path__ + "static/img/wheel-pan.69731b2a.png";